import ChatStream from '@features/ChatStreams/components/ChatStream';

export default ChatStream;
